import paths from 'routing/routes/_paths';

import CompanySettings from '@/views/companies/settings';
import Companies from 'views/companies';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.companies,
    component: Companies,
    documentTitle: 'Companies'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.company_settings,
    component: CompanySettings,
    documentTitle: 'Company Settings'
  },
  {
    type: 'private',
    exact: true,
    app: true,
    path: `${paths.company_settings}/:id`,
    component: CompanySettings,
    documentTitle: 'Company Settings'
  }
];

export default routes;
